export default "__VITE_ASSET__DOVxk5z7__";